import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Modal, Radio, RadioGroup } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import classNames from 'classnames';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import ShopContact from '../organisms/ShopContact';
import AnyButton from '../../components/atoms/AnyButton';
import { sendLogin, isAuthenticated } from '../../auth/Auth';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmSettingDialogTextButton from '../../components/atoms/ConfirmSettingDialogTextButton';
import ConfirmDeleteSettingDialogTextButton from '../../components/atoms/ConfirmDeleteSettingDialogTextButton';
import ValidationText from '../../components/atoms/ValidationText';
import {
  getSettingGochiKidShop,
  updateSettingGochiKidShop,
  deleteSettingGochiKidShop
} from '../../actions/Shop';
import AddButtonNoText from '../../components/atoms/AddButtonNoText';
import RemoveButtonNoText from '../../components/atoms/RemoveButtonNoText';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  mainPaper: {
    margin: 15
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 20,
    textAlign: 'left',
    backgroundColor: '#F7F7F7',
    fontSize: '24 !important'
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24
  },
  mainModal: {
    zIndex: '99999!important'
  },
  buttonWrapper: {
    padding: '20px 20px 1px 20px',
    marginBottom: 39
  },
  button: {
    width: '100%',
    marginBottom: '19px',
    fontSize: 14,
    fontWeight: 'bold'
  },
  supportTimeTxt: {
    fontSize: 14,
    margin: '0 15px 15px'
  },
  twoItems: {
    display: 'flex'
  },
  ml5: {
    marginLeft: 5
  },
  mr5: {
    marginRight: 5
  },
  textSubTitle: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 700,
    paddingBottom: 10,
    paddingTop: 30
  },
  textSubTitle2: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 700,
    paddingBottom: 10,
    paddingTop: 30,
    color: '#F50057'
  },
  noBorder: {
    border: 0
  },
  description: {
    fontSize: 18,
    fontWeight: 700,
    marginTop: 5
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  noPaddingTop: {
    paddingTop: 0
  },
  noPaddingBottom: {
    paddingBottom: 0
  },
  widthInput: {
    width: '100%'
  },
  noMargin: {
    margin: 0
  },
  andTime: {
    padding: 0,
    paddingTop: 40
  },
  checkbox: {
    marginRight: 15,
    '& span': {
      fontWeight: 700
    }
  },
  inputDate: {
    backgroundColor: '#fff',
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none',
    borderBottomWidth: '0.5px',
    fontSize: 16,
    marginTop: '4px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const defaulSettings = {
  gochiKidUseSettingId: null,
  dayUseWeek: [1, 2, 3, 4, 5, 6, 7],
  useStartTime: null,
  useEndTime: null,
  validHoliday: 1,
  limitNumUsedDay: null,
  shopHolidays: []
};

const LIMIT_SETTING_USE_SHOP = 100000;

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getSettingGochiKidShop,
          updateSettingGochiKidShop,
          deleteSettingGochiKidShop
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openShopContact', 'setOpenShopContact', false),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('openDialog', 'updateOpenDialog', false),
  withState('openDeleteDialog', 'updateOpenDeleteDialog', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('dayUseWeek', 'setdayUseWeek', []),
  withState('loading', 'updateLoading', false),
  withState(
    'settings',
    'setSettings',
    JSON.parse(JSON.stringify(defaulSettings))
  ),
  withState('settingSuccess', 'updateSettingSuccess', false),
  withState('hasSetting', 'setHasSetting', true),
  withState('dateError', 'setDateError', ''),
  withState('limitNumUseDayError', 'setLimitNumUseDayError', ''),
  withState('isEdit', 'setIsEdit', false),
  withState('shopHolidayList', 'setShopHolidayList', []),
  withState('isFirstCall', 'setIsFirstCall', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions
        .getSettingGochiKidShop(this.props.account.shopId)
        .then(settingShopData => {
          if (
            settingShopData.type === 'GET_SETTING_GOCHI_KID_SUCCESS' &&
            settingShopData.payload
          ) {
            this.props.setSettings(settingShopData.payload);
            this.props.setShopHolidayList(
              settingShopData.payload.shopHolidays.map(value => value.holiday)
            );
            this.props.setHasSetting(true);
            this.props.setIsFirstCall(true);
          } else if (
            settingShopData.type === 'GET_SETTING_GOCHI_KID_FAILURE' &&
            settingShopData.payload &&
            settingShopData.payload.data &&
            settingShopData.payload.data.errorInfo &&
            settingShopData.payload.data.errorInfo.code ===
              'exception.errors.not.found.resource'
          ) {
            this.props.setSettings(JSON.parse(JSON.stringify(defaulSettings)));
            this.props.setShopHolidayList(['']);
            this.props.setHasSetting(false);
            this.props.setIsFirstCall(true);
          } else {
            this.props.setShopHolidayList(['']);
            this.props.setHasSetting(false);
            this.props.setIsFirstCall(true);
          }
        });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    checkSession,
    name,
    handleRedirect,
    openShopContact,
    setOpenShopContact,
    loading,
    updateLoading,
    resultMessage,
    setResultMessage,
    openDialog,
    updateOpenDialog,
    openProgress,
    updateOpenProgress,
    settings,
    setSettings,
    settingSuccess,
    updateSettingSuccess,
    openDeleteDialog,
    updateOpenDeleteDialog,
    dateError,
    setDateError,
    hasSetting,
    setHasSetting,
    limitNumUseDayError,
    setLimitNumUseDayError,
    isEdit,
    setIsEdit,
    shopHolidayList,
    setShopHolidayList,
    isFirstCall
  }) => {
    const errors = {
      dateError,
      limitNumUseDayError
    };
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }

    const validate = () => {
      const regex = /^[!@#$%^&*(),.?":{}|<>]+$/;
      if (
        (settings.useStartTime && !settings.useEndTime) ||
        (settings.useEndTime && !settings.useStartTime) ||
        (settings.useStartTime &&
          settings.useEndTime &&
          settings.useStartTime === settings.useEndTime)
      ) {
        setDateError('必須項目です。');
        return 0;
      }
      if (settings.limitNumUsedDay && regex.test(settings.limitNumUsedDay)) {
        setLimitNumUseDayError('必須項目です。');
        return 0;
      }
      setLimitNumUseDayError('');
      setDateError('');
      return 1;
    };

    const listDay = [
      { label: '月', value: 1 },
      { label: '火', value: 2 },
      { label: '水', value: 3 },
      { label: '木', value: 4 },
      { label: '金', value: 5 },
      { label: '土', value: 6 },
      { label: '日', value: 7 }
    ];

    const progressOkAction = () => {
      if (settingSuccess) {
        updateOpenProgress(false);
        updateLoading(false);
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const handleUseStartTime = async e => {
      const dataSetting = JSON.parse(JSON.stringify(settings));
      if (dataSetting.useEndTime && dataSetting.useEndTime < e) {
        dataSetting.useEndTime = null;
      }
      dataSetting.useStartTime = e;
      setSettings(dataSetting);
    };

    const handleUseEndTime = async e => {
      const dataSetting = JSON.parse(JSON.stringify(settings));
      if (dataSetting.useStartTime && dataSetting.useStartTime > e) {
        dataSetting.useStartTime = null;
      }
      dataSetting.useEndTime = e;
      setSettings(dataSetting);
    };

    const handleChangeLimit = async e => {
      const dataSetting = JSON.parse(JSON.stringify(settings));
      dataSetting.limitNumUsedDay = e ? parseInt(e, 10) : null;
      setSettings(dataSetting);
    };

    const handleChangeDay = (day, value) => {
      const dataSetting = JSON.parse(JSON.stringify(settings));
      if (
        (value && dataSetting && dataSetting.dayUseWeek.length === 0) ||
        (value &&
          dataSetting &&
          dataSetting.dayUseWeek &&
          !dataSetting.dayUseWeek.includes(day))
      ) {
        dataSetting.dayUseWeek.push(day);
      } else if (!value && dataSetting.dayUseWeek.includes(day)) {
        const newdayUseWeek = dataSetting.dayUseWeek.filter(v => {
          return v !== day;
        });
        dataSetting.dayUseWeek = newdayUseWeek;
      }
      setSettings(dataSetting);
    };

    const handleValidHoliday = value => {
      const dataSetting = JSON.parse(JSON.stringify(settings));
      dataSetting.validHoliday = value ? 1 : 0;
      setSettings(dataSetting);
    };

    const addShopHoliday = () => {
      const tempList = [...shopHolidayList];
      tempList.push('');
      setShopHolidayList(tempList);
    };

    const showEdit = value => {
      if (isEdit || !hasSetting) {
        updateOpenDialog(value);
      } else {
        if (shopHolidayList.length === 0) {
          addShopHoliday();
        }
        setIsEdit(true);
      }
    };

    const handleChangeShopHoliday = (value, index) => {
      const tempList = [...shopHolidayList];
      if (value !== '') {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tempList.length; i++) {
          if (tempList[i] === value) {
            tempList[index] = '';
            setShopHolidayList(tempList);
            updateOpenProgress(true);
            setResultMessage('重複に設定しないでください。');
            return;
          }
        }
      }
      tempList[index] = value;
      setShopHolidayList(tempList);
    };

    const removeShopHoliday = index => {
      const tempList = [...shopHolidayList];
      tempList.splice(index, 1);
      setShopHolidayList(tempList);
    };

    const updateSettingAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const tempSetting = { ...settings };
      const tempShopHolidayList = shopHolidayList.filter(value => value !== '');
      tempSetting.shopHolidays = tempShopHolidayList;
      const updateSetting = await actions
        .updateSettingGochiKidShop(account.shopId, tempSetting)
        .then(data => checkSession(data));
      if (updateSetting.type === 'UPDATE_SETTING_GOCHI_KID_SUCCESS') {
        await actions
          .getSettingGochiKidShop(account.shopId)
          .then(settingShopData => {
            if (
              settingShopData.type === 'GET_SETTING_GOCHI_KID_SUCCESS' &&
              settingShopData.payload
            ) {
              setSettings(settingShopData.payload);
              setShopHolidayList(
                settingShopData.payload.shopHolidays.map(value => value.holiday)
              );
              setHasSetting(true);
              setIsEdit(false);
            } else if (
              settingShopData.type === 'GET_SETTING_GOCHI_KID_FAILURE' &&
              settingShopData.payload.data.errorInfo.code ===
                'exception.errors.not.found.resource'
            ) {
              setSettings(JSON.parse(JSON.stringify(defaulSettings)));
              this.props.setShopHolidayList(['']);
              setHasSetting(false);
            }
          });
        updateSettingSuccess(true);
        setResultMessage('設定が完了しました。');
        updateLoading(false);
      } else {
        updateSettingSuccess(false);
        if (
          updateSetting.payload &&
          updateSetting.payload.status &&
          updateSetting.payload.status === 409
        ) {
          setResultMessage('エラーが発生しました');
        } else {
          setResultMessage('エラーが発生しました');
        }
        updateLoading(false);
      }
    };

    const deleteSettingAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const deleteSetting = await actions
        .deleteSettingGochiKidShop(account.shopId)
        .then(data => checkSession(data));
      if (deleteSetting.type === 'DELETE_SETTING_GOCHI_KID_SHOP_SUCCESS') {
        setSettings(JSON.parse(JSON.stringify(defaulSettings)));
        setShopHolidayList(['']);
        setHasSetting(false);
        updateSettingSuccess(true);
        setResultMessage('設定を削除しました。');
        updateLoading(false);
        setIsEdit(false);
      } else {
        updateSettingSuccess(false);
        if (
          deleteSetting.payload.status &&
          deleteSetting.payload.status === 409
        ) {
          setResultMessage('エラーが発生しました！');
        } else {
          setResultMessage('エラーが発生しました！');
        }
        updateLoading(false);
      }
    };

    return (
      <div className={classes.root}>
        <Header name={name} />
        <div className={classes.pageTitileDiv}>
          <Typography color="textPrimary" className={classes.textTitle}>
            こどもごちめし
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow className={classes.borderBottom}>
                {!hasSetting ? (
                  <TableCell className={classes.textSubTitle} colspan="3">
                    利用制限の設定
                  </TableCell>
                ) : (
                  <TableCell
                    className={
                      isEdit ? classes.textSubTitle : classes.textSubTitle2
                    }
                    colspan="3"
                  >
                    {isEdit
                      ? '設定済み利用制限情報の編集'
                      : '設定済み利用制限の情報'}
                  </TableCell>
                )}
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder]} colspan="3">
                  <AnyButton />
                  <div className={classes.description}>利用曜日を設定</div>
                  <div
                    style={{ fontSize: 14, fontWeight: 700, color: '#7F7F7F' }}
                  >
                    利用可能な曜日にチェックを入れてください。
                  </div>
                </TableCell>
              </TableRow>
              <TableRow className={classes.noBorder}>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingTop]}
                  colspan="3"
                >
                  <div className={classes.list}>
                    {Object.keys(listDay).length !== 0 &&
                      listDay.map(day => {
                        return (
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    settings &&
                                    settings.dayUseWeek &&
                                    settings.dayUseWeek.length > 0 &&
                                    settings.dayUseWeek.includes(day.value)
                                      ? settings.dayUseWeek.includes(day.value)
                                      : false
                                  }
                                  color="primary"
                                  onChange={e => {
                                    handleChangeDay(
                                      day.value,
                                      e.target.checked
                                    );
                                  }}
                                  name="dayUseWeek"
                                  disabled={!isEdit && hasSetting}
                                />
                              }
                              className={classes.checkbox}
                              label={day.label}
                            />
                          </FormGroup>
                        );
                      })}
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingTop]}
                  colspan="3"
                >
                  <div
                    style={{ fontSize: 14, fontWeight: 700, color: '#7F7F7F' }}
                  >
                    祝日利用
                  </div>
                </TableCell>
              </TableRow>
              <TableRow className={classes.noBorder}>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingTop]}
                  colspan="3"
                >
                  <div className={classes.list}>
                    <FormGroup>
                      <RadioGroup
                        row
                        value={settings && settings.validHoliday}
                        onChange={e => {
                          const allowed = parseInt(e.target.value, 10);
                          handleValidHoliday(allowed);
                        }}
                        className={classes.radioGroup}
                        name="validHoliday"
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              利用可
                            </Typography>
                          }
                          disabled={!isEdit && hasSetting}
                        />
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              利用不可
                            </Typography>
                          }
                          disabled={!isEdit && hasSetting}
                        />
                      </RadioGroup>
                    </FormGroup>
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingBottom]}
                  colspan="3"
                >
                  <AnyButton />
                  <div className={classes.description}>不定休の設定</div>
                </TableCell>
              </TableRow>
              {shopHolidayList.length > 0 &&
                shopHolidayList.map((value, index) => {
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <TableRow key={index}>
                      <TableCell
                        className={[classes.noBorder, classes.noPaddingBottom]}
                        colspan="2"
                      >
                        <div>日付</div>
                        <input
                          type="date"
                          name="holidayShop"
                          value={value}
                          className={classNames(
                            classes.widthInput,
                            classes.inputDate
                          )}
                          onChange={opt => {
                            handleChangeShopHoliday(opt.target.value, index);
                          }}
                          disabled={!isEdit && hasSetting}
                        />
                      </TableCell>
                      {(isEdit || !hasSetting) && (
                        <TableCell
                          className={[
                            classes.noBorder,
                            classes.noPaddingBottom
                          ]}
                          style={{ verticalAlign: 'bottom' }}
                        >
                          <RemoveButtonNoText
                            onClickAction={() => removeShopHoliday(index)}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              {(isEdit || !hasSetting) && (
                <TableRow>
                  <TableCell className={[classes.noBorder]} colspan="3">
                    <AddButtonNoText
                      disabled={!isEdit && hasSetting}
                      onClickAction={() => addShopHoliday()}
                      message="追加"
                      color="default"
                    />
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingBottom]}
                  colspan="3"
                >
                  <AnyButton />
                  <div className={classes.description}>利用時間を設定</div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingBottom]}
                >
                  <div>開始</div>
                  <span>
                    <input
                      type="time"
                      min="00:00"
                      max="24:00"
                      name="useStartTime"
                      value={
                        settings && settings.useStartTime
                          ? settings.useStartTime
                          : ''
                      }
                      className={classNames(
                        classes.widthInput,
                        classes.inputDate
                      )}
                      onChange={opt => {
                        handleUseStartTime(opt.target.value);
                      }}
                      disabled={!isEdit && hasSetting}
                    />
                  </span>
                </TableCell>
                <TableCell className={[classes.noBorder, classes.andTime]}>
                  ~
                </TableCell>
                <TableCell
                  className={[classes.noBorder, classes.noPaddingBottom]}
                >
                  <div>終了</div>
                  <span>
                    <input
                      type="time"
                      min="00:00"
                      max="24:00"
                      name="useEndTime"
                      value={
                        settings && settings.useEndTime
                          ? settings.useEndTime
                          : ''
                      }
                      className={classNames(
                        classes.widthInput,
                        classes.inputDate
                      )}
                      onChange={opt => {
                        handleUseEndTime(opt.target.value);
                      }}
                      disabled={!isEdit && hasSetting}
                    />
                  </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.noBorder} colspan="3">
                  <ValidationText message={errors.dateError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={[classes.noBorder]} colspan="3">
                  <AnyButton />
                  <div className={classes.description}>利用人数を設定</div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colspan="3"
                  className={[classes.noBorder, classes.noPaddingTop]}
                >
                  <TextField
                    label="人数（1日につき）"
                    placeholder=""
                    fullWidth
                    type="tel"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={
                      settings && settings.limitNumUsedDay
                        ? settings.limitNumUsedDay
                        : ''
                    }
                    className={(classes.textField, classes.noMargin)}
                    margin="normal"
                    onChange={e => {
                      const regex = /^[0-9\b]+$/;
                      if (
                        e.target.value === '' ||
                        (regex.test(e.target.value) &&
                          parseInt(e.target.value, 10) <=
                            LIMIT_SETTING_USE_SHOP &&
                          e.target.value > 0)
                      ) {
                        handleChangeLimit(e.target.value);
                      } else {
                        handleChangeLimit(1);
                      }
                    }}
                    disabled={!isEdit && hasSetting}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.noBorder} colspan="3">
                  <ValidationText message={errors.limitNumUseDayError} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow className={classes.borderBottom}>
                <TableCell className={[classes.tableCellBorderNone]}>
                  <ConfirmSettingDialogTextButton
                    message="Are you sure?"
                    content={!hasSetting ? '設定する' : '編集する'}
                    openDialog={openDialog}
                    settings={settings}
                    listDay={listDay}
                    updateOpenDialog={showEdit}
                    onClickAction={updateSettingAction}
                    validate={validate}
                    hasSetting={hasSetting}
                    disabled={!isFirstCall}
                    shopHolidayList={shopHolidayList}
                  />
                  {hasSetting && !isEdit && (
                    <ConfirmDeleteSettingDialogTextButton
                      message="Are you sure?"
                      content="削除する"
                      openDialog={openDeleteDialog}
                      updateOpenDialog={updateOpenDeleteDialog}
                      onClickAction={deleteSettingAction}
                    />
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <MenuBox account={account} />
        <div>
          <Modal open={openShopContact} className={classes.mainModal}>
            <ShopContact setOpenShopContact={setOpenShopContact} />
          </Modal>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
